<usb-base-modal
  [title]="title"
  [subtitle]="subtitle"
  [confirmText]="confirmText"
  [confirmSubText]="confirmSubText"
  [cancelText]="cancelText"
  [showCancelButton]="showCancelButton"
  [showExtraButton]="true"
  [extraText]="extraText"
  [size]="size"
  [titleReverse]="titleReverse"
  [icon]="icon"
>
  <div class="delete-transfer-content">
    <p class="delete-transfer-message" [innerHTML]="message"></p>
  </div>
</usb-base-modal>
